import { API_DETAILS, COOKIE_KEYS } from '../../App';
import Cookies from 'js-cookie';
import axios from 'axios';
import React, {useState, useEffect} from 'react';
import { Link } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import displayIcon from '../../assets/Display_icon.png';
import Loader from '../../utils/loader';

const AppointmentsViewer=()=>{
  const uId = Cookies.get(COOKIE_KEYS.userId);
  // Opens on today rather than an empty prompt — the day a provider wants to see
  // is almost always the current one.
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [appointments, setAppointments] = useState([]);
  const [activeLoader, setActiveLoader] = useState(false);

  const fetchAppointments = async (date) => {
    console.log("$$$$$$$$$$$$$$Fetching data for:", date);

    // Local calendar date, not toISOString(). toISOString() converts to UTC, so
    // any evening east of Greenwich rolled over to the following day and the
    // viewer quietly showed tomorrow's appointments.
    const formattedDate = [
      date.getFullYear(),
      String(date.getMonth() + 1).padStart(2, '0'),
      String(date.getDate()).padStart(2, '0'),
    ].join('-'); // Format: YYYY-MM-DD
    console.log("$$$$$$$$$$$$$$formatted date:", formattedDate);
    const url = API_DETAILS.baseUrl + API_DETAILS.PORT + API_DETAILS.baseExtension + `/appointments/${uId}/byDate?timeZone=${Intl.DateTimeFormat().resolvedOptions().timeZone}&date=${formattedDate}`;
    const config = {
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': '*',
        'Content-Type': 'application/json'
      }
    };
    try {
      setActiveLoader(true);
      const res = await axios.get(url, config);
      console.log("%%%%%%%%%%DATA:", res);
      const combinedAppointments = [
        ...res.data.previousAppointments,
        ...res.data.upComingAppointments,
      ];
      setAppointments(combinedAppointments);
    } catch (err) {
      console.error('Error fetching appointments:', err);
    } finally {
      setActiveLoader(false);
    }
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
    fetchAppointments(date);
  };

  // Load today's appointments on mount so the panel is useful straight away.
  useEffect(() => {
    fetchAppointments(selectedDate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const shiftDay = (days) => {
    const next = new Date(selectedDate);
    next.setDate(next.getDate() + days);
    handleDateChange(next);
  };

  const isToday = selectedDate.toDateString() === new Date().toDateString();

  const Appointments = () => {
    const [data, setData] = useState([]);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedApptId, setSelectedApptId] = useState(null);
    const [descriptionText, setDescriptionText] = useState('');
    const [selectedPatientId, setSelectedPatientId] = useState(null);

    return (
      <div>
        {
          (appointments == null || appointments.length == 0) && <>
            <div className='new-ua' style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '33%' }}>
              <h3><i>No record of appointments</i></h3>
            </div>
            </>
        }

        {appointments && appointments.length != 0 && appointments.map((item) => (
          <div className='previous-appointment'>
            <div>
              <h5 style={{ display: 'inline-block', marginTop: '5px' }}>
                {new Date(item.apptStartTime).toLocaleDateString()}, {' '}
                {new Date(item.apptStartTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true })}
              </h5>
              {item.status === 'CANCELED' && <div className='cancel-tag'>cancelled</div>}
              <div style={{ display: 'flex', flexDirection: 'row', height: '30px', marginBottom: '3%', alignItems: 'center' }}>
                  <img
                      src={item.picture ? `data:image/png;base64,${item.picture}` : displayIcon}
                      className="profile-pic" alt="Patient Image" width="30" height="30" style={{ marginRight: '10px'}}/>

                <h5 style={{marginLeft: '40px', margin: 0}}>
                  {/* Opens the chart, same target as the name on the upcoming
                      appointments list. Reaching a patient from here previously
                      meant going to Patient Details and finding them again. */}
                  <Link
                    style={{ textDecoration: 'none', color: 'inherit' }}
                    to={`/doctor-view-profile/${item.patientId}`}
                  >
                    {item.patientName}
                  </Link>
                </h5>
              </div>
            </div>
            <ul key={item.apptId}>
              <li>Diagnosis: {item.diagName}</li>
              <li style={{ textDecoration: 'underline', color: 'var(--youro-sage)', cursor: 'pointer' }}>
                <Link
                  style={{ textDecoration: 'none', color: 'inherit' }}
                  to={`/doctor-view-profile/${item.patientId}`}
                >
                  View Chart
                </Link>
              </li>
            </ul>

          </div>
        ))
        }

      </div>
    );
  };

  return (
      <div>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px', marginBottom: '1rem' }}>
          <button
            type="button"
            aria-label="Previous day"
            className="apptv-nav"
            onClick={() => shiftDay(-1)}
          >
            ‹
          </button>
          <DatePicker
            selected={selectedDate}
            onChange={handleDateChange}
            customInput={<StylingDatePicker />}
          />
          <button
            type="button"
            aria-label="Next day"
            className="apptv-nav"
            onClick={() => shiftDay(1)}
          >
            ›
          </button>
        </div>

        {!isToday && (
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '0.75rem' }}>
            <button type="button" className="apptv-today" onClick={() => handleDateChange(new Date())}>
              Back to today
            </button>
          </div>
        )}

        {
          !activeLoader && selectedDate && appointments.length === 0 && <>
            <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <h3 style={{ marginTop: '39%' }}><i>No appointments for selected date</i></h3>
            </div>
          </>
        }

        {!activeLoader && appointments.length > 0 && (
          <div className='care-plan-details-patient-1-scroll-section'>
            <Appointments />
          </div>
        )}
        <Loader active={activeLoader} />
      </div>
  );
}

const StylingDatePicker = React.forwardRef(({ value, onClick }, ref) => (
  <input
    type="text"
    onClick={onClick}
    ref={ref}
    value={value}
    placeholder="Select a date"
    style={{
      marginBottom: '0.5rem',
      width: '160px',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      padding: '0.375rem 0.75rem',
      border: '1px solid #ccc',
      borderRadius: '4px',
      fontSize: '1rem',
      fontFamily: 'inherit',
      backgroundColor: '#fff',
      appearance: 'none',
      boxSizing: 'border-box',
      height: '38px',
      cursor: 'pointer',
    }}
  />
));

export default AppointmentsViewer;